/**
 * @generated SignedSource<<7b3ad36cfb4ab1a0281f27e7369ab47e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MetricProgress = "DECREASING" | "INCREASING";
export type MetricType = "CURRENCY" | "NUMBER" | "PERCENTAGE";
export type KeyResultMutationInput = {
  assigneeTeam?: string | null;
  assigneeUser?: string | null;
  dueDate?: any | null;
  id?: string | null;
  metricCurrency?: string | null;
  metricCurrent?: number | null;
  metricProgress?: MetricProgress | null;
  metricStart?: number | null;
  metricTarget?: number | null;
  metricType?: MetricType | null;
  objective: string;
  order?: number | null;
  title?: string | null;
  weight?: number | null;
};
export type KeyResultCreateOrEditMutation$variables = {
  keyResult: KeyResultMutationInput;
};
export type KeyResultCreateOrEditMutation$data = {
  readonly KeyResult_CreateEdit: {
    readonly keyResult: {
      readonly assigneeTeam: {
        readonly id: string;
        readonly title: string;
      } | null;
      readonly assigneeUser: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
      } | null;
      readonly dueDate: string | null;
      readonly id: string;
      readonly metricCurrency: string | null;
      readonly metricCurrent: number;
      readonly metricProgress: MetricProgress;
      readonly metricStart: number;
      readonly metricTarget: number;
      readonly metricType: MetricType;
      readonly order: number;
      readonly progress: number;
      readonly title: string;
      readonly weight: number;
    };
  } | null;
};
export type KeyResultCreateOrEditMutation = {
  response: KeyResultCreateOrEditMutation$data;
  variables: KeyResultCreateOrEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "keyResult"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "keyResult",
        "variableName": "keyResult"
      }
    ],
    "concreteType": "CreateEditKeyResultMutation",
    "kind": "LinkedField",
    "name": "KeyResult_CreateEdit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyResult",
        "kind": "LinkedField",
        "name": "keyResult",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assigneeUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isGuest",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "assigneeTeam",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metricProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metricType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metricCurrency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metricStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metricCurrent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metricTarget",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "order",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KeyResultCreateOrEditMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KeyResultCreateOrEditMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "161a46c2f0ee2dbce4323166a137025c",
    "id": null,
    "metadata": {},
    "name": "KeyResultCreateOrEditMutation",
    "operationKind": "mutation",
    "text": "mutation KeyResultCreateOrEditMutation(\n  $keyResult: KeyResultMutationInput!\n) {\n  KeyResult_CreateEdit(keyResult: $keyResult) {\n    keyResult {\n      id\n      title\n      dueDate\n      assigneeUser {\n        id\n        email\n        image\n        fullName\n        isGuest\n      }\n      assigneeTeam {\n        id\n        title\n      }\n      metricProgress\n      metricType\n      metricCurrency\n      metricStart\n      metricCurrent\n      metricTarget\n      weight\n      order\n      progress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7ac960402bf2ec70f930c277f7632d2";

export default node;
